import {
  ClientService,
  ClientProvider,
  ClientNotesProvider,
  ClientMonitoringsProvider,
  ClientRiskLevelsProvider,
  ClientDelegatesProvider,
  ClientSearchProvider,
  HttpService,
  ClientAddFormDataProvider,
  ClientCheckDublicateProvider,
  ClientReqFieldsProvider,
  ClientSelectsProvider,
  ClientRelationsProvider,
  ClientBlacklistProvider,
  ClientWatchlistProvider,
  ClientSmsprovider,
  ClientPermissionsProvider,
  ClientValidatePinProvider,
  ClientIdDocProvider,
  ClientContactVerifyProvider,
  ClientTagProvider,
} from '@lk/api'

export const makeClientService = (http: HttpService, baseUrl: string): ClientService =>
  new ClientService(
    new ClientProvider(http, baseUrl),
    new ClientNotesProvider(http, baseUrl),
    new ClientMonitoringsProvider(http, baseUrl),
    new ClientRiskLevelsProvider(http, baseUrl),
    new ClientDelegatesProvider(http, baseUrl),
    new ClientSearchProvider(http, baseUrl),
    new ClientAddFormDataProvider(http, baseUrl),
    new ClientCheckDublicateProvider(http, baseUrl),
    new ClientReqFieldsProvider(http, baseUrl),
    new ClientSelectsProvider(http, baseUrl),
    new ClientRelationsProvider(http, baseUrl),
    new ClientBlacklistProvider(http, baseUrl),
    new ClientWatchlistProvider(http, baseUrl),
    new ClientSmsprovider(http, baseUrl),
    new ClientPermissionsProvider(http, baseUrl),
    new ClientValidatePinProvider(http, baseUrl),
    new ClientIdDocProvider(http, baseUrl),
    new ClientContactVerifyProvider(http, baseUrl),
    new ClientTagProvider(http, baseUrl),
  )
